import { render } from "./BaCalendar.vue?vue&type=template&id=7aa52f08"
import script from "./BaCalendar.vue?vue&type=script&lang=js"
export * from "./BaCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__